/*
 * AI related functions
 */
import HTMLString from '@/utils/classes/HTMLString';
import $ from 'jquery';

var $iaModals = null, iaIndexIncr = 1;
$(document).ready(function() {
  $iaModals = [];
})
function newIaModal() {
  if (!$iaModals) {
    return null;
  }
  var index = ++iaIndexIncr;
  var iaModal = $.parseHTML('<div class="ia-modal" id="ia-modal-' + index + '" class="f-h f-w">\
    <div class="f-w f-h" style="position:relative">\
      <div class="ia-box-wrapper">\
        <div class="ia-box-head"><img class="ia-modal-img" src="/images/ia/happy.png" alt="" /></div>\
        <div class="ia-box content-gradient">\
          <div class="sensei-wrapper">\
            <img src="/images/ia/sensei-full.png" alt="" />\
          </div>\
          <div class="content-wrapper f-h">\
            <div class="ia-modal-text"></div>\
            <div class="ia-modal-btns"></div>\
          </div>\
        </div>\
      </div>\
    </div>\
  </div>')[0];
  var m = $(iaModal);
  $iaModals.push(m);
  $('body').append(m);
  return m;
}

/** Displays a modal assistant box.
  @Param message: message of the dialog box
  @Param buttons: array of object like { title: '', action: function(){} }
                may also contain an 'anchor' param if the button should be added after the anchor (added at the end otherwise)
  @Param offset: iaModal offset. Default value: {top: 20px, bottom: 20px, left: 20px, right: unset, width: unset, height: unset}
  @Param face: IA face. default: 'happy'. May be 'analyst', 'help' or 'sensei'
  @Param onHide: if set, function triggered when this modal is hidden
*/
export function iaModal(message, buttons, offset, face, onHide) {
  var iaFace = face || "happy";
  var $iaModal = newIaModal();
  if (!$iaModal) {
    setTimeout(function() {
      iaModal(message, buttons);
    }, 50);
    return;
  }
  const index = iaIndexIncr;
  // Set new content
  $("#ia-modal-" + index + " .ia-modal-img").attr("src", "/images/ia/" + iaFace + ".png");
  $("#ia-modal-" + index + " .ia-modal-text").html(message);
  for (var i = 0, len = buttons.length ; i < len ; i++) {
    var btn = $.parseHTML('<button class="action-btn no-shadow">' + buttons[i].title + '</button><br/>');
    const finalI = i;
    if (buttons[i].anchor) {
      $("#" + buttons[i].anchor).after(btn);
    } else {
      $("#ia-modal-" + index + " .ia-modal-btns").append(btn);
    }
    btn[0].onclick = function() {
      if (!buttons[finalI].keepOn) {
        iaModalHide();
      }
      if (typeof buttons[finalI].action == "function") {
        buttons[finalI].action();
      }
    }
    if (buttons[i].sClass) {
      btn[0].className = btn[0].className + " " + buttons[i].sClass;
    }
  }
  var $iaModalWrapper = $iaModal.find(".ia-box-wrapper");
  $iaModal.css("z-index", "10025");
  $iaModal.animate({opacity: 1}, 300);
  // Dismiss
  detectEscapeKey(function() {
    iaModalHide(true);
  });
  $iaModal.on("click", function() {
    iaModalHide();
  });
  if (onHide) {
    $iaModal.onHide = onHide;
  }
  $iaModalWrapper.on("click", function (e) {
    e.stopPropagation();
  });
  $iaModalWrapper.css("position", "absolute");
  $iaModalWrapper.css("top", offset.top || "20px");
  $iaModalWrapper.css("bottom", offset.bottom || "20px");
  $iaModalWrapper.css("left", offset.left || "20px");
  $iaModalWrapper.css("right", offset.right || "unset");
  $iaModalWrapper.css("width", offset.width || "unset");
  $iaModalWrapper.css("height", offset.height || "unset");
  return $iaModal;
}

export function senseiModal(title, message, buttons, offset, face, onHide) {
  var message = new HTMLString().line(title, {cClass: "sensei-title"}).line(message).toString();
  var mod = iaModal(message, buttons, offset, face, onHide);
  mod.addClass("sensei");
}

/** Hide the alert shown with calert(..) */
export function iaModalHide(keepEscKeyCallback) {
  const index = $iaModals.length - 1;
  if (index > -1) {
    if (!keepEscKeyCallback) {
      undetectEscapeKey();
    }
    const $iaModal = $iaModals[index];
    $iaModals.splice(index, 1);
    if ($iaModal.onHide) {
      $iaModal.onHide();
    }
    $iaModal.animate({opacity: 0}, 300, function() {
      $iaModal.remove();
    });
  }
}

export default {
  iaModal,
  iaModalHide,
  senseiModal,
};
